import { useRouter } from "next/router";

export const useCurrentProjectId = (): string => {
  const router = useRouter();
  return router.query?.project_id as string;
};
